import { CorruptedGcpType } from "../../../apiFacades/bapi/gcpRequests";
import {
  getFlightMarkerById,
  IFlightMarkersState,
} from "../../modules/flightMarkers/flightMarkersReducer";
import { IGCPRequestState } from "../../modules/gcpRequest/reducer";
import { IFlightMarker } from "../../../apiFacades/bapi/flightMarkers";
import { Black, White } from "@traceair/tds";

export function getFlightMarkerIcon(
  flightMarkersState: IFlightMarkersState,
  gcpRequestState: IGCPRequestState,
  flightMarkerId: string,
): string {
  const marker = getFlightMarkerById(flightMarkersState, flightMarkerId);
  const corruptedStatus = gcpRequestState.corruptedFlightMarkers[
    marker.id
  ] as CorruptedGcpType;
  return getCorruptedMarkerIcon(marker, corruptedStatus);
}

export const getCorruptedMarkerIcon = (
  marker: IFlightMarker,
  corruptedStatus?: CorruptedGcpType,
) => {
  if (marker.tsArchived) {
    return `icon-gcp-transparent.svg`;
  }

  if (
    [CorruptedGcpType.REPLACE_BROKEN, CorruptedGcpType.REPLACE_SMALL].includes(
      corruptedStatus,
    )
  ) {
    return `icon-gcp-red.svg`;
  }

  if (
    [
      CorruptedGcpType.CLEANUP_STUFF,
      CorruptedGcpType.CLEANUP_DIRT,
      CorruptedGcpType.CLEANUP_REPAINT,
      CorruptedGcpType.FIX_COORDINATES,
      CorruptedGcpType.CHECK_CONDITION,
      CorruptedGcpType.OTHER,
    ].includes(corruptedStatus as CorruptedGcpType)
  ) {
    return `icon-gcp-yellow.svg`;
  }

  return `icon-gcp.svg`;
};

interface IMarkerColors {
  color: string;
  outlineColor: string;
}

export const getCorruptedIconColors = (
  corruptedStatus?: CorruptedGcpType,
): IMarkerColors => {
  if (
    [CorruptedGcpType.REPLACE_BROKEN, CorruptedGcpType.REPLACE_SMALL].includes(
      corruptedStatus,
    )
  ) {
    return {
      color: "rgba(255, 60, 70, 1)",
      outlineColor: White,
    };
  }
  if (
    [
      CorruptedGcpType.CLEANUP_STUFF,
      CorruptedGcpType.CLEANUP_DIRT,
      CorruptedGcpType.CLEANUP_REPAINT,
      CorruptedGcpType.FIX_COORDINATES,
      CorruptedGcpType.CHECK_CONDITION,
      CorruptedGcpType.OTHER,
    ].includes(corruptedStatus as CorruptedGcpType)
  ) {
    // don't seem to have the right color in the current tds version
    return {
      color: "rgba(229, 192, 4, 1)",
      outlineColor: White,
    };
  }
  // isn't actually a valid color combination, just avoiding type errors
  return {
    color: Black,
    outlineColor: White,
  };
};
